<template>
  <section>
    <b-row>
      <b-col md="12" class="d-flex justify-content-end">
        <!-- <b-button class="my-2" to="/support/submit" target="_blank"> -->
        <b-button
          class="my-2 text-end"
          v-b-modal.modal-main
          target="_blank"
          variant="primary"
        >
          Submit a ticket
        </b-button></b-col
      >
    </b-row>

    <b-modal
      id="modal-main"
      cancel-variant="outline-secondary"
      centered
      title="Add Ticket Form"
      @hide="resetForm"
      hide-footer
    >
      <validation-observer ref="formAddTicket" #default="{ invalid }">
        <b-form @submit.prevent="submitTicket">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Customer"
                label-for="h-Customer-Id"
                label-cols-md="4"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Customer"
                  vid="Customer"
                >
                  <div
                    v-if="loadingCustomerList"
                    class="d-flex justify-content-center"
                  >
                    <b-spinner></b-spinner>
                  </div>
                  <b-form-select
                    v-if="!loadingCustomerList"
                    v-model="customer"
                    :options="optionsCustomer"
                    :state="errors.length > 0 ? false : null"
                    @change="customerSelected(customer)"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Title" label-for="title" label-cols-md="4">
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Title"
                >
                  <b-form-input
                    id="title"
                    v-model="title"
                    type="text"
                    placeholder="Title"
                    :state="errors.length > 0 ? false : null"
                    required
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Category"
                label-for="category"
                label-cols-md="4"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Category"
                  vid="Category"
                >
                  <b-form-select
                    :options="optionsCategory"
                    required
                    :state="errors.length > 0 ? false : null"
                    v-model="category"
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Products / Services"
                label-for="h-Product"
                label-cols-md="4"
              >
                <!-- <v-select
                v-model="selected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="title"
                :options="option"
              /> -->
                <div
                  v-if="loadingProductList"
                  class="d-flex justify-content-center"
                >
                  <b-spinner></b-spinner>
                </div>
                <b-form-select
                  v-if="!loadingProductList"
                  :options="productOptions"
                  v-model="product"
                />
                <!-- <b-form-select
                v-model="ticketData.itemId"
                :options="product"
                @change="productSelected(itemId)"
                multiple
              /> -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Description"
                label-for="description"
                label-cols-md="4"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Description"
                >
                  <b-form-textarea
                    id="description"
                    v-model="description"
                    class="mb-2 mb-lg-0"
                    required
                    :state="errors.length > 0 ? false : null"
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Assigned To"
                label-for="assigned"
                label-cols-md="4"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Assigned To"
                  vid="Assigned To"
                >
                  <div
                    v-if="loadingSalesPersonList"
                    class="d-flex justify-content-center"
                  >
                    <b-spinner></b-spinner>
                  </div>
                  <b-form-select
                    v-if="!loadingSalesPersonList"
                    id="assigned"
                    :options="optionsAssignedTo"
                    :state="errors.length > 0 ? false : null"
                    required
                    v-model="assignedTo"
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Status" label-for="status" label-cols-md="4">
                <validation-provider
                  rules="required"
                  v-slot="{ errors }"
                  name="Status"
                  vid="Status"
                >
                  <b-form-select
                    id="status"
                    v-model="status"
                    :state="errors.length > 0 ? false : null"
                    :options="statusOptions"
                    required
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Priority"
                label-for="priority"
                label-cols-md="4"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Priority"
                  vid="Priority"
                >
                  <b-form-select
                    id="priority"
                    v-model="priority"
                    :options="options"
                    :state="errors.length > 0 ? false : null"
                    required
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Comments"
                label-for="h-comment"
                label-cols-md="4"
              >
                <b-form-textarea v-model="comments" class="mb-2 mb-lg-0" />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                label="Due Date"
                label-for="due_date"
                label-cols-md="4"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Due Date"
                  vid="Due Date"
                >
                  <b-form-datepicker
                    id="due_date"
                    placeholder="Choose a date"
                    local="en"
                    :state="errors.length > 0 ? false : null"
                    v-model="dueDate"
                  />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- submit and reset -->
            <b-col offset-md="4">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                @click="submitTicket()"
                :disabled="submitting"
                type="submit"
                variant="primary"
                class="mr-1"
              >
                <b-spinner small v-if="submitting"></b-spinner>
                {{ submitting ? "Submitting..." : "Submit" }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <div>
      <b-row class="justify-content-between">
        <b-col md="2" sm="4" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <div class="d-flex justify-content-center mb-1">
            <b-spinner
              variant="success"
              label="Spinning"
              block
              v-if="loading"
              style="width: 3rem; height: 3rem"
            ></b-spinner>

            <b-table
              v-else
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="ticket"
              :fields="fields"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template #cell(status)="data">
                <b-badge :variant="getStatusVariant(data.item.status)">
                  {{ data.item.status }}
                </b-badge>
              </template>

              <template #cell(customerId)="data">
                {{ getCustomer(data.item.customerId) }}
              </template>
              <template #cell(assignedTo)="data">
                {{ getSalePersonName(data.item.assignedTo) }}
              </template>
              <template #cell(openDate)="data">
                {{ formatDate(data.item.openDate) }}
              </template>
              <template #cell(dueDate)="data">
                {{ formatDate(data.item.dueDate) }}
              </template>
              <template #cell(priority)="data">
                <b-badge :variant="getPriorityVariant(data.item.priority)">
                  {{ data.item.priority }}
                </b-badge>
              </template>
              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item :to="getTicketId(data.item.id)">
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50">View</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </b-col>

        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
          <b-form-group>
            Showing 
            {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
            to 
            {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
            of 
            {{ totalRows > 0 ? totalRows : 0 }} 
            entries
        </b-form-group>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BForm,
  BModal,
  BAlert,
  BLink,
  BContainer,
  BFormCheckbox,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormDatepicker,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormDatepicker,
    BButton,
    BForm,
    BModal,
    BAlert,
    BLink,
    BRow,
    BContainer,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    ToastificationContent,
    vSelect,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      // validation rules
      required,
      email,
      // ticket data
      customer: "",
      title: "",
      category: "",
      product: "",
      description: "",
      assignedTo: "",
      status: "",
      priority: "",
      comments: "",
      dueDate: "",
      // ticket data
      dir: "ltr",
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      ticketData: [],
      filterOn: [],
      customerNames: [],
      assignedToNames: [],
      loading: true,
      optionsCustomer: [],
      optionsAssignedTo: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      productOptions: [],
      optionsCategory: [
        { value: "GeneralInquiry", text: "General" },
        { value: "Billing", text: "Billing" },
      ],
      statusOptions: [
        { value: "Open", text: "Open" },
        { value: "Closed", text: "Closed" },
      ],
      options: [
        { value: "Low", text: "Low" },
        { value: "Medium", text: "Medium" },
        { value: "High", text: "High" },
      ],

      content: `<h1>Ticket</h1>
  <h2>Write your ticket description</h2>
  <p><br></p>
  <pre>
</pre>  `,
      fields: [
        { key: "reference", label: "Ticket Number", sortable: true },
        { key: "customerId", label: "Customer Name", sortable: true },
        { key: "name", label: "Title", sortable: true },
        { key: "category", label: "Category", sortable: true },
        { key: "assignedTo", label: "Assigned To", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "priority", label: "Priority", sortable: true },
        { key: "openDate", label: "Created Date", sortable: true },
        { key: "dueDate", label: "Due Date", sortable: true },
        "Actions",
      ],
      priority: [
        {
          1: "Low",
          2: "Medium",
          3: "High",
        },
        {
          1: "light-secondary",
          2: "light-warning",
          3: "light-danger",
        },
      ],
      submitting: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },

    ...mapGetters("ticketModule", {
      ticket: "ticket",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      custId: "custId",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      productID: "productID",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
  },
  methods: {
    ...mapActions("ticketModule", [
      "addTicketAction",
      "getTicketListAction",
      "getTicketIdAction",
      "removeTicketAction",
      "updateTicketAction",
    ]),

    ...mapActions("productModule", [
      "getProductListAction",
      "getProductIDAction",
    ]),
    ...mapActions("customerModule", [
      "getCustomersListAction",
      "getCustomersByIDAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    getTicketData(data) {
      this.ticketData = data;
    },
    getTicketId(id) {
      return "/support/ticket-view/" + id;
    },

    getCustomer(id) {
      const customer = this.CustomerList.find((s) => s.id === id);
      return customer ? customer.otherName : "-";
    },
    getSalePersonName(id) {
      const salesPerson = this.SalesPersonList.find((s) => s.id === id);
      return salesPerson
        ? salesPerson.firstName + " " + salesPerson.lastName
        : "-";
    },
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    getStatusVariant(status) {
      switch (status) {
        case "Open":
          return "light-secondary";
        case "Closed":
          return "light-success";
        default:
          return "secondary";
      }
    },
    getPriorityVariant(priority) {
      switch (priority) {
        case "Low":
          return "light-secondary";
        case "Medium":
          return "light-warning";
        case "High":
          return "light-danger";
        default:
          return "secondary";
      }
    },

    successAdd() {
      this.$swal({
        title: "Ticket Added!",
        text: "You have successfully added a ticket!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorAdd() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    successEdit() {
      this.$swal({
        title: "Ticket Updated!",
        text: "You have successfully updated a ticket!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorEdit() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getFormattedCurrentDateTime() {
      const now = new Date();
      const year = now.getUTCFullYear();
      const month = String(now.getUTCMonth() + 1).padStart(2, "0");
      const day = String(now.getUTCDate()).padStart(2, "0");
      const hours = String(now.getUTCHours()).padStart(2, "0");
      const minutes = String(now.getUTCMinutes()).padStart(2, "0");
      const seconds = String(now.getUTCSeconds()).padStart(2, "0");
      const milliseconds = String(now.getUTCMilliseconds()).padStart(3, "0");

      // Format the date and time string
      const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;

      return formattedDateTime;
    },

    async submitTicket() {
      this.submitting = true;
      const isValid = await this.$refs.formAddTicket.validate();
      if (isValid) {
        try {
          // Concatenate selected dueDate with midnight time string
          const defaultDueDate = this.dueDate + "T00:00:00.000Z";
          const payload = {
            customerId: this.customer,
            name: this.title,
            category: this.category,
            description: this.description,
            assignedTo: this.assignedTo,
            status: this.status,
            priority: this.priority,
            remark: this.comments,
            dueDate: defaultDueDate,
            openDate: this.getFormattedCurrentDateTime(),
          };
          await this.addTicketAction(payload);
          this.successAdd();
          // Reload ticket list after adding ticket successfully
          await this.getTicketListAction();
          this.resetForm();
          this.$bvModal.hide("modal-main");
        } catch (error) {
          console.error("Error adding ticket:", error);
          this.errorAdd();
          this.$bvModal.hide("modal-main");
        }
      } else {
        this.submitting = false;
      }
    },
    resetForm() {
      // Clear form fields
      this.customer = "";
      this.title = "";
      this.category = "";
      this.product = "";
      this.description = "";
      this.assignedTo = "";
      this.status = "";
      this.priority = "";
      this.comments = "";
      this.dueDate = "";
      // Reset submitting state
      this.submitting = false;
    },
    EditTicket() {
      let payload = this.ticketData;
      this.updateTicketAction(payload)
        .then(() => {
          this.successEdit();
          this.$bvModal.hide("modal-edit");
        })
        .catch(() => {
          this.errorEdit();
          this.$bvModal.hide("modal-edit");
        });
    },

    removeTicket(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeTicketAction(id);
          this.$swal({
            icon: "success",
            title: "Deleted!",
            text: "Ticket has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Ticket is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },

    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    productSelected(id) {
      this.getProductIDAction(id);
      this.productID = null;
    },

    customerSelected(id) {
      this.getCustomersByIDAction(id);
      this.custId = null;
    },
    updateItemForm(ind, val) {
      this.invoiceData.items[ind] = this.ProductList.filter(
        (v, i) => v.id == val
      )[0];
    },
  },

  async mounted() {
    this.loadingTicketList = true;
    this.loadingCustomerList = true;
    this.loadingSalesPersonList = true;
    this.loadingProductList = true;

    // Fetch ticket list
    await this.getTicketListAction().then(() => {
      this.items = this.ticket;
      this.totalRows = this.ticket.length;
      // Populate customerNames array
      this.ticket.forEach((item) => {
        if (!this.customerNames.includes(item.customerName)) {
          this.customerNames.push(item.customerName);
        }
      });
      this.loadingTicketList = false;
    });

    // Fetch customer list
    this.getCustomersListAction().then(() => {
      this.CustomerList.map((v, i) =>
        this.optionsCustomer.push({
          value: v.id,
          text: `${(v.otherName ??= v.companyName)} ${(v.surname ??= "")}`,
          item: v,
        })
      );
      this.loadingCustomerList = false;
    });
    // get list of salesperson
    this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsAssignedTo.push({
          value: v.id,
          text: `${v.firstName + " " + v.lastName}`,
          item: v,
        })
      );
      // Populate assignedToNames array
      this.SalesPersonList.forEach((person) => {
        const fullName = `${person.firstName} ${person.lastName}`;
        if (!this.assignedToNames.includes(fullName)) {
          this.assignedToNames.push(fullName);
        }
      });
      this.loadingSalesPersonList = false;
    });
    // Fetch product list
    this.getProductListAction(true).then(() => {
      this.ProductList.map((v, i) => {
        this.productOptions.push({ value: v.id, text: `${v.name}` });
      });
      this.loadingProductList = false;
    });

    // Once all data is loaded, set loading to false
    Promise.all([
      this.getTicketListAction(),
      this.getCustomersListAction(),
      this.getProductListAction(true),
      this.getSalesPersonListAction(),
    ]).then(() => {
      this.loading = false;
    });
  },
};
</script>
